import type * as definitions from "~/definitions";
import { deserialize, deserializeWith, rename, t } from "desero";
import { FoodCategory, Moment } from "~/models";

/**
 * A meal of a menu.
 * @hideconstructor
 */
export class Meal {
  /**
   * Each categories of the meal.
   */
  @deserializeWith((plats: definitions.foodcategory | Array<definitions.foodcategory>, self) => {
    if (Array.isArray(plats)) {
      return Meal.handleFoodCategories(
        plats.map((plats) => deserialize(FoodCategory, plats)),
        self
      );
    }

    return Meal.handleFoodCategories([
      deserialize(FoodCategory, plats)
    ], self);
  })
  @rename("plats")
  categories = t.array(t.reference(FoodCategory));

  /**
   * Sometimes, when something goes wrong or when something needs to be shared
   * (e.g.: they exceptionnaly close for this day) it is written here
   * and `categories` ends up being an empty list.
   */
  information: null | string = null;

  /**
   * For when this meal is made for during the day.
   */
  @rename("nom")
  moment = t.enum(Moment);

  private static handleFoodCategories(array: Array<FoodCategory>, self: Meal): Array<FoodCategory> {
    return array
      .filter((category) => {
        if (category.name === "informations" || category.name === "Fermeture") {
          self.information ??= category.dishes[0];
          return false;
        }

        return true;
      });
  }
}
